import { IconActionClose16, IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TChatImageLoader = {
  isLoading: boolean;
  withCancel?: boolean;
  withReload?: boolean;
  onCancel?: () => void;
  onReload?: () => void;
};

export const ChatImageLoader: React.FC<TChatImageLoader> = ({
  isLoading,
  withCancel,
  withReload,
  onCancel,
  onReload,
}) => {
  return (
    <div className={styles['container']}>
      {(isLoading || withCancel) && <div className={styles['loader']} />}
      {withCancel && onCancel && (
        <div className={styles['cancel_button']} onClick={onCancel} data-testid="cancel_button">
          <IconActionClose16 color="icon-inverted-default" />
        </div>
      )}
      {withReload && onReload && (
        <div className={styles['icon_button']} onClick={onReload}>
          <IconActionReload16 color="icon-inverted-default" />
        </div>
      )}
    </div>
  );
};
